<template>
    
    <div class="studio-booking">

        <div class="step-wrapper">
            <div class="step"><a href="javascript:void(0)" class="prev" v-if="step > 1" @click="onStepPrev()"><i class="fa fa-angle-left" aria-hidden="true"></i></a>
            {{ step }}/3</div>
        </div>

        <div class="row">

            <div class="col-sm-12">

                <VueSlickCarousel v-bind="slicksettings" ref="carousel">

                    <div class="slide">

                        <h5>1. Leistung wählen</h5>

                        <div class="form-group">
                        
                            <p class="form-text text-muted">Bitte wählen Sie die gewünschte Leistung aus</p>
                            <select v-model="selectedService" class="form-control" @change="onSelectedService()">
                                <option value="">Bitte aus der Liste wählen</option>
                                <option v-for="service in services" :key="service.id" :value="service.id" required>{{ service.name }}<!--({{ service.duration }} min)--></option>
                            </select>
                        
                        </div>

                    </div> <!-- /.slide -->

                    <div class="slide">

                        <div v-if="selectedService">

                            <div v-if="availableSlots.length == 0">
                                <p>Leider wurden keine passenden Buchungstermine gefunden.</p>
                                <p>Sehr gerne organisieren wir für Sie an diesem Tag auch noch einen kurzfristigen Termin.<br />Bitte rufen Sie uns unter der 08135-937-100 an und wir kümmern uns darum.</p>
                            </div>

                            <div v-else>

                                <h5>2. Datum und Uhrzeit auswählen</h5>

                                <p class="form-text text-muted" v-if="attributes.min_date >= Date.now()">Der Anbieter bietet ab dem <strong>{{ attributes.min_date | formatDate }}</strong> die Buchung von Online-Terminen an.</p>

                                <div class="form-group">
                                    <vc-date-picker v-model="selectedDate" :value="null" :min-date='attributes.min_date' is-inline is-expanded title-position="left" :available-dates='attributes.available_dates' @dayclick='dayClicked' />
                                </div>

                                <p>Welche Zeit passt Ihnen am <strong>{{ availableSlots.selectedDate | formatDate }}</strong> am besten?</p>

                                <div class="row no-gutters">
                                    <div class="col-sm-3" v-for="slot in availableSlots.slots" :key="slot.start" @click="onSelectSlot(slot)">
                                        <div class="booking-slot p-2 mb-2 shadow rounded">
                                        <!--<div class="col-sm-9">
                                            <h5 class="text-primary m-0">{{ services[selectedService].name }}</h5>
                                            <p class="small text-muted m-0">Bei: {{ availableSlots.calendars[slot.calendar_id].title }}</p>
                                            <p class="small text-muted m-0">Dauer: {{ services[selectedService].duration }} min</p>
                                            <p class="small text-muted m-0">Datum: {{ slot.start | formatDateTime }}</p> 
                                        </div>
                                        <div class="col align-self-center text-right" v-if="services[selectedService].price !== '0.00'">
                                            <span class="price" v-if="services[selectedService].price">{{ services[selectedService].price }} €</span>
                                        </div>-->
                                        <p class="small m-0 text-center">{{ slot.start | formatTimeSlot }}</p>
                                        </div>
                                    </div>
                                </div>

                                <p class="small info">Ihr Wunschtermin ist nicht mehr frei? Für kurzfristige Termine kontaktieren Sie uns bitte telefonisch unter <strong>08135 937-100</strong>.</p>

                            </div>

                        </div>

                    </div> <!-- /.slide -->

                    <div class="slide">

                        <div v-if="selectedService && selectedSlot">

                            <h5>3. Infos & Kontaktdaten<i v-if="services[selectedService].accepts_payment_mollie" class="fa fa-credit-card-alt" aria-hidden="true"></i> </h5>

                            <div class="review-booking">

                                <div class="booking-data p-2 mb-2 shadow rounded">
                                    <div class="row">
                                        <div class="col-sm-9">
                                            <h5 class="text-primary m-0">{{ services[selectedService].name }}</h5>
                                            <!--<p class="small text-muted m-0">Dauer: {{ services[selectedService].duration }} min</p>-->
                                            <p class="small text-muted m-0">Datum: {{ selectedSlot.start | formatDateTime }}</p>
                                        </div>
                                        <div class="col align-self-center text-right" v-if="services[selectedService].price !== '0.00'">
                                            <span class="price">{{ services[selectedService].price }} €</span>
                                        </div>
                                    </div>
                                </div>

                                <!-- Form booking start -->
                                <form class="form-booking" @submit.prevent="onPayNow">

                                    <!-- Freistaat Start -->
                                    <div v-if="selectedService == 5">

                                        <div class="form-row">

                                            <div class="form-group col-md-12 my-2">
                                                <label class="form-label d-block">Fahrzeugtyp:</label>
                                                <div class="form-check form-check-inline">
                                                    <input class="form-check-input" v-model="formmeta.fahrzeugtyp" type="checkbox" id="inlineCheckbox1" value="Wohnmobil">
                                                    <label class="form-check-label" for="inlineCheckbox1">Wohnmobil</label>
                                                </div>
                                                <div class="form-check form-check-inline">
                                                    <input class="form-check-input" v-model="formmeta.fahrzeugtyp" type="checkbox" id="inlineCheckbox2" value="Wohnwagen">
                                                    <label class="form-check-label" for="inlineCheckbox2">Wohnwagen</label>
                                                </div>
                                                <div class="form-check form-check-inline">
                                                    <input class="form-check-input" v-model="formmeta.fahrzeugtyp" type="checkbox" id="inlineCheckbox3" value="Kastenwagen / Camper Van">
                                                    <label class="form-check-label" for="inlineCheckbox3">Kastenwagen / Camper Van</label>
                                                </div>
                                            </div>

                                            <div class="form-group col-md-12 my-2" v-if="fahrzeugtyp('Wohnmobil')">
                                                <label class="form-label d-block">Kategorie:</label>
                                                <div class="form-check form-check-inline">
                                                    <input class="form-check-input" v-model="formmeta.kategorie" type="checkbox" id="inlineCheckbox40" value="Alkoven">
                                                    <label class="form-check-label" for="inlineCheckbox40">Alkoven</label>
                                                </div>
                                                <div class="form-check form-check-inline">
                                                    <input class="form-check-input" v-model="formmeta.kategorie" type="checkbox" id="inlineCheckbox41" value="Integrierter">
                                                    <label class="form-check-label" for="inlineCheckbox41">Integrierter</label>
                                                </div>
                                                <div class="form-check form-check-inline">
                                                    <input class="form-check-input" v-model="formmeta.kategorie" type="checkbox" id="inlineCheckbox42" value="Teilintegrierter">
                                                    <label class="form-check-label" for="inlineCheckbox42">Teilintegrierter</label>
                                                </div>
                                            </div>

                                            <div class="form-group col-md-12 my-2">
                                                <label class="form-label d-block">Zustand:</label>
                                                <div class="form-check form-check-inline">
                                                    <input class="form-check-input" v-model="formmeta.zustand" type="checkbox" id="inlineCheckbox4" value="Neu">
                                                    <label class="form-check-label" for="inlineCheckbox4">Neu</label>
                                                </div>
                                                <div class="form-check form-check-inline">
                                                    <input class="form-check-input" v-model="formmeta.zustand" type="checkbox" id="inlineCheckbox5" value="Gebraucht">
                                                    <label class="form-check-label" for="inlineCheckbox5">Gebraucht</label>
                                                </div>
                                            </div>

                                            <div class="form-group col-md-12 my-2" v-if="formmeta.fahrzeugtyp.length">
                                                <label class="form-label d-block">Für welche Marke interessieren Sie sich:</label>

                                                <div class="alle-haendler">

                                                    <div class="glueck haendler rounded">
                                                        <div class="haendlerlogo"><img src="/images/freistaat/glueck.png" /></div>
                                                        <div class="form-check form-check-inline" v-if="fahrzeugtyp('Kastenwagen / Camper Van')">
                                                            <input class="form-check-input" v-model="formmeta.marke" type="checkbox" id="inlineCheckbox7" value="Campster" @change="haendlerCount()">
                                                            <label class="form-check-label" for="inlineCheckbox7">Campster</label>
                                                        </div>
                                                        <div class="form-check form-check-inline" v-if="fahrzeugtyp('Kastenwagen / Camper Van')">
                                                            <input class="form-check-input" type="checkbox" v-model="formmeta.marke" id="inlineCheckbox10" value="Clever" @change="haendlerCount()">
                                                            <label class="form-check-label" for="inlineCheckbox10">Clever</label>
                                                        </div>
                                                        <div class="form-check form-check-inline" v-if="(!formmeta.kategorie.length && fahrzeugtyp('Wohnmobil')) || kategorie('Alkoven') || kategorie('Integrierter')">
                                                            <input class="form-check-input" type="checkbox" v-model="formmeta.marke" id="inlineCheckbox11" value="Concorde" @change="haendlerCount()">
                                                            <label class="form-check-label" for="inlineCheckbox11">Concorde</label>
                                                        </div>
                                                        <div class="form-check form-check-inline" v-if="fahrzeugtyp('Wohnmobil') || fahrzeugtyp('Wohnwagen')">
                                                            <input class="form-check-input" type="checkbox" v-model="formmeta.marke" id="inlineCheckbox12" value="Dethleffs" @change="haendlerCount()">
                                                            <label class="form-check-label" for="inlineCheckbox12">Dethleffs</label>
                                                        </div>
                                                        <div class="form-check form-check-inline" v-if="(!formmeta.kategorie.length && fahrzeugtyp('Wohnmobil')) || kategorie('Teilintegrierter')">
                                                            <input class="form-check-input" type="checkbox" v-model="formmeta.marke" id="inlineCheckbox17" value="Glücksmobil" @change="haendlerCount()">
                                                            <label class="form-check-label" for="inlineCheckbox17">Glücksmobil</label>
                                                        </div>
                                                        <div class="form-check form-check-inline" v-if="(!formmeta.kategorie.length && fahrzeugtyp('Wohnmobil')) || kategorie('Integrierter')">
                                                            <input class="form-check-input" type="checkbox" v-model="formmeta.marke" id="inlineCheckbox25" value="Morelo" @change="haendlerCount()">
                                                            <label class="form-check-label" for="inlineCheckbox25">Morelo</label>
                                                        </div>
                                                        <div class="form-check form-check-inline" v-if="(!formmeta.kategorie.length && fahrzeugtyp('Wohnmobil')) || kategorie('Alkoven') || kategorie('Integrierter')">
                                                            <input class="form-check-input" type="checkbox" v-model="formmeta.marke" id="inlineCheckbox27" value="Phoenix" @change="haendlerCount()">
                                                            <label class="form-check-label" for="inlineCheckbox27">Phoenix</label>
                                                        </div>
                                                        <div class="form-check form-check-inline" v-if="fahrzeugtyp('Kastenwagen / Camper Van')">
                                                            <input class="form-check-input" type="checkbox" v-model="formmeta.marke" id="inlineCheckbox28" value="Poessl" @change="haendlerCount()">
                                                            <label class="form-check-label" for="inlineCheckbox28">Poessl</label>
                                                        </div>
                                                        <div class="form-check form-check-inline" v-if="fahrzeugtyp('Wohnmobil')">
                                                            <input class="form-check-input" type="checkbox" v-model="formmeta.marke" id="inlineCheckbox30" value="Sunlight" @change="haendlerCount()">
                                                            <label class="form-check-label" for="inlineCheckbox30">Sunlight</label>
                                                        </div>
                                                        <div class="form-check form-check-inline" v-if="fahrzeugtyp('Wohnwagen')">
                                                            <input class="form-check-input" type="checkbox" v-model="formmeta.marke" id="inlineCheckbox31" value="Tabbert" @change="haendlerCount()">
                                                            <label class="form-check-label" for="inlineCheckbox31">Tabbert</label>
                                                        </div>
                                                        <div class="form-check form-check-inline" v-if="fahrzeugtyp('Kastenwagen / Camper Van')">
                                                            <input class="form-check-input" type="checkbox" v-model="formmeta.marke" id="inlineCheckbox32" value="Vanster" @change="haendlerCount()">
                                                            <label class="form-check-label" for="inlineCheckbo32">Vanster</label>
                                                        </div>
                                                    </div>

                                                    <div class="hymer haendler rounded">
                                                        <div class="haendlerlogo"><img src="/images/freistaat/hymer.png" /></div>
                                                        <div class="form-check form-check-inline" v-if="fahrzeugtyp('Wohnmobil')">
                                                            <input class="form-check-input" type="checkbox" v-model="formmeta.marke" id="inlineCheckbox8" value="Carado" @change="haendlerCount()">
                                                            <label class="form-check-label" for="inlineCheckbox8">Carado</label>
                                                        </div>
                                                        <div class="form-check form-check-inline" v-if="fahrzeugtyp('Wohnwagen')">
                                                            <input class="form-check-input" type="checkbox" v-model="formmeta.marke" id="inlineCheckbox14" value="Eriba" @change="haendlerCount()">
                                                            <label class="form-check-label" for="inlineCheckbox14">Eriba</label>
                                                        </div>
                                                        <div class="form-check form-check-inline" v-if="fahrzeugtyp('Wohnmobil')">
                                                            <input class="form-check-input" type="checkbox" v-model="formmeta.marke" id="inlineCheckbox13" value="Etrusco" @change="haendlerCount()">
                                                            <label class="form-check-label" for="inlineCheckbox13">Etrusco</label>
                                                        </div>
                                                        <div class="form-check form-check-inline" v-if="(!formmeta.kategorie.length && fahrzeugtyp('Wohnmobil')) || kategorie('Integrierter') || kategorie('Teilintegrierter')">
                                                            <input class="form-check-input" type="checkbox" v-model="formmeta.marke" id="inlineCheckbox19" value="Hymer" @change="haendlerCount()">
                                                            <label class="form-check-label" for="inlineCheckbox19">Hymer</label>
                                                        </div>
                                                        <div class="form-check form-check-inline" v-if="fahrzeugtyp('Kastenwagen / Camper Van')">
                                                            <input class="form-check-input" type="checkbox" v-model="formmeta.marke" id="inlineCheckbox20" value="Hymercar" @change="haendlerCount()">
                                                            <label class="form-check-label" for="inlineCheckbox20">Hymercar</label>
                                                        </div>
                                                        <div class="form-check form-check-inline" v-if="(!formmeta.kategorie.length && fahrzeugtyp('Wohnmobil')) || kategorie('Integrierter')">
                                                            <input class="form-check-input" type="checkbox" v-model="formmeta.marke" id="inlineCheckbox26" value="Niesmann + Bischoff" @change="haendlerCount()">
                                                            <label class="form-check-label" for="inlineCheckbox26">Niesmann + Bischoff</label>
                                                        </div>
                                                    </div>

                                                    <div class="zellerer-crm haendler rounded">
                                                        <div class="haendlerlogo noflex"><img src="/images/freistaat/zellerer.png" /> <img src="/images/freistaat/crm.png" class="img-fluid" /></div>
                                                        <div class="form-check form-check-inline" v-if="(!formmeta.kategorie.length && fahrzeugtyp('Wohnmobil')) || fahrzeugtyp('Wohnwagen') || kategorie('Integrierter') || kategorie('Teilintegrierter')">
                                                            <input class="form-check-input" v-model="formmeta.marke" type="checkbox" id="inlineCheckbox6" value="Bürstner" @change="haendlerCount()">
                                                            <label class="form-check-label" for="inlineCheckbox6">Bürstner</label>
                                                        </div>
                                                        <div class="form-check form-check-inline" v-if="fahrzeugtyp('Wohnwagen')">
                                                            <input class="form-check-input" type="checkbox" v-model="formmeta.marke" id="inlineCheckbox15" value="Fendt" @change="haendlerCount()">
                                                            <label class="form-check-label" for="inlineCheckbox15">Fendt</label>
                                                        </div>
                                                        <div class="form-check form-check-inline" v-if="fahrzeugtyp('Kastenwagen / Camper Van')">
                                                            <input class="form-check-input" type="checkbox" v-model="formmeta.marke" id="inlineCheckbox16" value="Globecar" @change="haendlerCount()">
                                                            <label class="form-check-label" for="inlineCheckbox16">Globecar</label>
                                                        </div>
                                                        <div class="form-check form-check-inline" v-if="fahrzeugtyp('Wohnwagen')">
                                                            <input class="form-check-input" type="checkbox" v-model="formmeta.marke" id="inlineCheckbox21" value="Kabe" @change="haendlerCount()">
                                                            <label class="form-check-label" for="inlineCheckbox21">Kabe</label>
                                                        </div>
                                                        <div class="form-check form-check-inline" v-if="fahrzeugtyp('Wohnmobil')">
                                                            <input class="form-check-input" type="checkbox" v-model="formmeta.marke" id="inlineCheckbox22" value="Laika" @change="haendlerCount()">
                                                            <label class="form-check-label" for="inlineCheckbox22">Laika</label>
                                                        </div>
                                                        <div class="form-check form-check-inline" v-if="fahrzeugtyp('Kastenwagen / Camper Van')">
                                                            <input class="form-check-input" type="checkbox" v-model="formmeta.marke" id="inlineCheckbox29" value="Roadcar" @change="haendlerCount()">
                                                            <label class="form-check-label" for="inlineCheckbox29">Roadcar</label>
                                                        </div>
                                                    </div>

                                                    <div class="hofstetter haendler rounded">
                                                        <div class="haendlerlogo"><img src="/images/freistaat/hofstetter.png" /></div>
                                                        <div class="form-check form-check-inline" v-if="(!formmeta.kategorie.length && fahrzeugtyp('Wohnmobil')) || kategorie('Integrierter') || kategorie('Teilintegrierter')">
                                                            <input class="form-check-input" type="checkbox" v-model="formmeta.marke" id="inlineCheckbox9" value="Carthago" @change="haendlerCount()">
                                                            <label class="form-check-label" for="inlineCheckbox9">Carthago</label>
                                                        </div>
                                                        <div class="form-check form-check-inline" v-if="(!formmeta.kategorie.length && fahrzeugtyp('Wohnmobil')) || fahrzeugtyp('Wohnwagen') || fahrzeugtyp('Kastenwagen / Camper Van') || kategorie('Alkoven') || kategorie('Teilintegrierter')">
                                                            <input class="form-check-input" type="checkbox" v-model="formmeta.marke" id="inlineCheckbox18" value="Hobby" @change="haendlerCount()">
                                                            <label class="form-check-label" for="inlineCheckbox18">Hobby</label>
                                                        </div>
                                                        <div class="form-check form-check-inline" v-if="(!formmeta.kategorie.length && fahrzeugtyp('Wohnmobil')) || fahrzeugtyp('Wohnwagen') || kategorie('Integrierter') || kategorie('Teilintegrierter')">
                                                            <input class="form-check-input" type="checkbox" v-model="formmeta.marke" id="inlineCheckbox23" value="LMC" @change="haendlerCount()">
                                                            <label class="form-check-label" for="inlineCheckbox23">LMC</label>
                                                        </div>
                                                        <div class="form-check form-check-inline" v-if="(!formmeta.kategorie.length && fahrzeugtyp('Wohnmobil')) || fahrzeugtyp('Kastenwagen / Camper Van') || kategorie('Integrierter') || kategorie('Teilintegrierter')">
                                                            <input class="form-check-input" type="checkbox" v-model="formmeta.marke" id="inlineCheckbox24" value="Malibu" @change="haendlerCount()">
                                                            <label class="form-check-label" for="inlineCheckbox24">Malibu</label>
                                                        </div>
                                                    </div>

                                                </div>

                                                <p class="small text-muted notice-wrap" v-if="selectedHaendler.length > 1">
                                                <span class="notice-red">Wir versuchen Ihren Terminwunsch bei den ausgewählten Händlern zu ermöglichen.</span><br />
                                                Die Besonderheit bei uns im Handelszentrum der Freistaat Caravaning & More ist, dass wir aus fünf Händlern bestehen, welche nach Marken unterteilt sind. So haben Sie die Möglichkeit sich wie auf einer Caravanmesse mehrere hunderte Wohnmobile und Wohnwagen auf einem Platz anzusehen und Angebote zu den verschiedenen Marken fußläufig einzuholen.<br />
                                                Zur Übersicht finden Sie <a href="https://www.derfreistaat.de/wp-content/uploads/misc/Freistaat_Wegeplan.pdf" target="_blank">hier</a> unseren Freistaat Lageplan.</p>

                                            </div>

                                        </div>

                                    </div>

                                    <div v-else>

                                        <div class="form-row">

                                            <div class="form-group col-md-12 my-2">
                                                <label class="form-label d-block">Sie interessieren sich für:</label>
                                                <div class="form-check form-check-inline">
                                                    <input class="form-check-input" v-model="formmeta.shop_interesse" type="checkbox" id="inlineCheckbox34" value="Vorzelt">
                                                    <label class="form-check-label" for="inlineCheckbox34">Vorzelt</label>
                                                </div>
                                                <div class="form-check form-check-inline">
                                                    <input class="form-check-input" v-model="formmeta.shop_interesse" type="checkbox" id="inlineCheckbox33" value="Erstausstattung">
                                                    <label class="form-check-label" for="inlineCheckbox33">Erstausstattung</label>
                                                </div>
                                                <div class="form-check form-check-inline">
                                                    <input class="form-check-input" v-model="formmeta.shop_interesse" type="checkbox" id="inlineCheckbox34" value="Technik">
                                                    <label class="form-check-label" for="inlineCheckbox34">Technik</label>
                                                </div>
                                            </div>

                                        </div>

                                    </div>

                                    <div class="form-group">
                                        <label class="form-label">Kommentar:</label>
                                        <textarea name="comment" v-model="formdata.comment" :placeholder="comment_placeholder" class="form-control" ></textarea>
                                    </div>

                                    <!-- Freistaat End -->                         

                                    <div class="form-row">

                                        <div class="form-group col-md-6">
                                            <label class="form-label">Vorname:</label>
                                            <input type="text" name="first_name" v-model="formdata.first_name" class="form-control">
                                        </div>

                                        <div class="form-group col-md-6">
                                            <label class="form-label">Nachname:</label>
                                            <input type="text" name="last_name" v-model="formdata.last_name" class="form-control">
                                        </div>

                                    </div>

                                    <div class="form-group">
                                        <label class="form-label">Straße und Hausnummer:</label>
                                        <input type="text" name="address" v-model="formdata.address" class="form-control">
                                    </div>

                                    <div class="form-row">

                                        <div class="form-group col-md-3">
                                            <label class="form-label">Postleitzahl:</label>
                                            <input type="text" name="zip" v-model="formdata.zip" class="form-control">
                                        </div>

                                        <div class="form-group col-md-9">
                                            <label class="form-label">Ort:</label>
                                            <input type="text" name="city" v-model="formdata.city" class="form-control">
                                        </div>

                                    </div>

                                    <div class="form-group">
                                        <label class="form-label">Telefonnnummer:</label>
                                        <input type="text" name="phone" v-model="formdata.phone" class="form-control">
                                        <p class="small text-muted">Bitte angeben für kurzfristige Rückfragen und SMS-Benachrichtigungen</p>
                                    </div>

                                    <div class="form-group">
                                        <label class="form-label">Ihre E-Mail Adresse*:</label>
                                        <input type="email" name="email" v-model="formdata.email" class="form-control" required>
                                    </div>

                                    <div class="form-group">
                                        <label class="form-label d-block">Anzahl Personen:</label>
                                        <div class="form-check form-check-inline">
                                            <input class="form-check-input" type="radio" v-model="formmeta.pax" name="inlineRadioOptions" id="inlineRadio1" value="1">
                                            <label class="form-check-label nomax" for="inlineRadio1">1</label>
                                        </div>
                                        <div class="form-check form-check-inline">
                                            <input class="form-check-input" type="radio" v-model="formmeta.pax" name="inlineRadioOptions" id="inlineRadio2" value="2">
                                            <label class="form-check-label nomax" for="inlineRadio2">2</label>
                                        </div>
                                        <div class="form-check form-check-inline">
                                            <input class="form-check-input" type="radio" v-model="formmeta.pax" name="inlineRadioOptions" id="inlineRadio3" value="3">
                                            <label class="form-check-label nomax" for="inlineRadio3">3</label>
                                        </div>
                                        <p class="small text-muted">Maximal 3 Personen</p>
                                    </div>

                                    <div v-if="!services[selectedService].accepts_payment_mollie">
                                        <button class="btn btn-primary btn-lg mb-2">Zur Terminbestätigung<sup>*</sup></button>
                                        <div v-if="services[selectedService].accepts_payment_cash"><p class="small text-muted">Der Anbieter stellt als Option <strong>Barzahlung vor Ort</strong> zur Verfügung.</p></div>
                                        <p class="small text-muted"><sup>*</sup> Bitte bestätigen Sie <strong>auf der nächsten Seite</strong> Ihre Terminanfrage.</p>
                                    </div>

                                    <div v-if="services[selectedService].accepts_payment_mollie">
                                        <button class="btn btn-primary btn-lg mb-2"><i class="fa fa-lock" aria-hidden="true"></i> Jetzt bezahlen</button>
                                        <p class="small text-muted">Sie werden an unseren Zahlungsdiensleister Mollie weitergeleitet. Nach erfolgreicher Bezahlung haben Sie den Termin gebucht.</p>
                                    </div>

                                </form>
                                <!-- Form booking end -->

                            </div>

                        </div>

                    </div>

                </VueSlickCarousel>

            </div> <!-- /.col-sm-12 -->

        </div> <!-- /.row -->
                        
    </div> <!-- /.studio-booking -->

</template>

<script>

    import VueSlickCarousel from 'vue-slick-carousel';
    import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

    export default {

        components: { VueSlickCarousel },

    	data() {
            return {
                services: [],
                selectedService: '',
                availableSlots: [],
                selectedSlot: '',
                formdata: { first_name: '', last_name: '', address: '', zip: '', city: '', phone: '', email: '', comment:'' },
                formmeta: { fahrzeugtyp: [], zustand: [], marke: [], kategorie: [], pax: '1', shop_interesse: [] },
                selectedHaendler: [],
                formerrors: {},
                selectedDate: '',
                suggestions: '',
                allTimeSlots: '',
                selectedCalendar: '',
                selectedTimeSlot: {},
                step: 1,
                attrs: [
                    {
                        //key: 'today',
                        //highlight: true,
                        //dates: new Date(),
                    },
                ],
                attributes:
                    {
                        min_date: '',
                        disabled_dates: { weekdays: [1] },
                        available_dates: [ new Date('2021-03-10'), new Date('2021-03-11') ]
                    },
                slicksettings: {
                  arrows: false,
                  dots: false,
                  infinite: false,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  draggable: false,
                  initialSlide: 0,
                  swipe: false
                },
                comment_placeholder: "" 
            };
        },

        mounted() {

            this.step = 1;
            var _this = this;
            //this.$refs.carousel.reSlick();

            axios.get('/api/studio/'+this.studioId+'/services')
            .then((response) => {
                _this.services = response.data;
                _this.$refs.carousel.goTo(0, true);
                _this.step = 1; 
                //setTimeout(function(){ _this.$refs.carousel.goToSlide(0); }, 500);
                console.log("goto0");
            });

            // fix to reset slick slider
            //setTimeout(function(){ this.$refs.carousel.goToSlide(0); }, 800);

        },

        computed: {
        },

        methods: {

            onSelectedService() {

                if(this.selectedService) {
                    var _this = this;
                    axios.get('/api/studio/'+this.studioId+'/get-slots/' + this.selectedService)
                    .then((response) => {
                        _this.availableSlots = response.data;
                        _this.selectedDate = new Date(response.data.selectedDate);
                        if(response.data.availableDates) {
                            var availableDatesArr = [];
                            var availableDates = response.data.availableDates;
                            //console.log(availableDates);
                            for (let key in availableDates) {
                                availableDatesArr.push(new Date((availableDates[key])));
                                //console.log(key, availableDates[key]);
                            }
                            _this.attributes.available_dates = availableDatesArr;
                        }
                        this.$refs.carousel.next();
                        this.step = 2;
                    });
                }
                else {
                    this.$refs.carousel.goTo(0, true);
                    this.step = 1; 
                }

                // Freistaat
                if(this.selectedService == 5) {
                    this.comment_placeholder = 'Sie haben Ihr Wunschfahrzeug bereits gefunden? Haben Sie bereits eine Marke die Ihnen besonders gut gefällt? Bitte teilen Sie uns Marke und Modell oder gerne die Interne Nummer aus unserer Fahrzeugsuche mit.';
                }
                else {
                    this.comment_placeholder = 'Für welches Produkt interessieren Sie sich? Wozu wünschen Sie Beratung?';
                }

            },

            onStepPrev() {
                this.step = this.step - 1;
                this.$refs.carousel.goTo(this.step - 1);
                if(this.step == 1) {
                    this.selectedService = '';
                }  
            },


            onSelectSlot(slot) {
                this.selectedSlot = slot;
                this.$refs.carousel.next();
                this.step = 3;
            },

            dayClicked(day) {
                //console.log(day);
                var _this = this;
                axios.get('/api/studio/'+this.studioId+'/get-slots/' + this.selectedService + '?d=' + day.id)
                .then((response) => {
                    _this.availableSlots = response.data;
                    _this.selectedDate = new Date(response.data.selectedDate);
                });
            },

            onPayNow() {

                console.log("click");

                if(this.selectedService == 5 && !this.formmeta.fahrzeugtyp.length) {
                    alert("Bitte wählen Sie mindestens einen Fahrzeugtypen.");
                    return;
                }
                if(this.selectedService == 5 && this.fahrzeugtyp('Wohnmobil') && !this.formmeta.kategorie.length) {
                    alert("Bitte wählen Sie mindestens eine Kategorie.");
                    return;
                }


                this.formerrors = '';
                var _this = this;

                var data = {
                    formdata: this.formdata,
                    eventdata: { start: this.selectedSlot.start, end: this.selectedSlot.end, sid: this.services[this.selectedService].id, cid: this.selectedSlot.calendar_id, ceid: this.selectedSlot.id  },
                    formmeta: this.formmeta
                }

                // create order
                axios.post('/order', data)
                .then((response) => {
                    //console.log(response);
                    if(response.status == 200) {
                        // redirect to mollie if payment is needed
                        if(_this.services[_this.selectedService].accepts_payment_mollie)
                            window.location.href = '/order/' + response.data + '/prepare-payment/';
                        else
                            window.location.href = '/order/' + response.data + '/proceed/?embed=1';
                    }
                })
                .catch(function (error) {
                    if (error.response) {
                        //alert("Leider ging etwas schief.");
                        console.log(error.response.data);
                        _this.formerrors = error.response.data.errors;
                        if(error.response.status == '422') {
                            alert("Bitte prüfen Sie Ihr Formular");
                        }
                        //console.log(error.response.data);
                        //console.log(error.response.headers);
                    }
                });

            },

            fahrzeugtyp(n) {
                return this.formmeta.fahrzeugtyp.indexOf(n) > -1
            },

            kategorie(n) {
                return this.formmeta.kategorie.indexOf(n) > -1
            },

            haendlerCount() {

                let selectedMarken = this.formmeta.marke;
                this.selectedHaendler = [];
                var haendler = '';
                var _this = this;

                selectedMarken.forEach(function(marke) {
                    if(marke == 'Campster' || marke == 'Clever' || marke == 'Concorde' || marke == 'Dethleffs' || marke == 'Glücksmobil' || marke == 'Morelo' || marke == 'Phoenix' || marke == 'Poessl' || marke == 'Sunlight' || marke == 'Tabbert' || marke == 'Vanster') {
                        haendler = 'Glück';
                        if(_this.selectedHaendler.indexOf(haendler) == -1) { _this.selectedHaendler.push(haendler); }
                    }
                    if(marke == 'Carado' || marke == 'Eriba' || marke == 'Etrusco' || marke == 'Hymer' || marke == 'Hymercar' || marke == 'Niesmann + Bischoff') {
                        haendler = 'Hymer';
                        if(_this.selectedHaendler.indexOf(haendler) == -1) { _this.selectedHaendler.push(haendler); }
                    }
                    if(marke == 'Bürstner' || marke == 'Fendt' || marke == 'Globecar' || marke == 'Kabe' || marke == 'Laika' || marke == 'Roadcar') {
                        haendler = 'CRM/Zellerer';
                        if(_this.selectedHaendler.indexOf(haendler) == -1) { _this.selectedHaendler.push(haendler); }
                    }
                    if(marke == 'Carthago' || marke == 'Hobby' || marke == 'LMC' || marke == 'Malibu') {
                        haendler = 'Hofstetter';
                        if(_this.selectedHaendler.indexOf(haendler) == -1) { _this.selectedHaendler.push(haendler); }
                    }
                });
                

            },




            checkBooking() {
                var _this = this;
                axios.post('/api/studio/' + this.studioId + '/check', this.$data)
                .then(function (response) {
                    _this.suggestions = response.data.finalSuggestions;
                    _this.allTimeSlots = response.data.allTimeSlots;
                    //_this.selectedDate = response.data[0];
                })
                .catch((error) => {
				    if (error.response) {
                        //alert("Bitte wählen Sie eine Leistung aus");
				        //console.log(error.response.data.errors);
				        //alert(error.response.data.errors);
				        //_this.errors = error.response.data.errors;
				    }
				});
            },

            bookNow() {
                axios.post('/api/studio/' + this.studioId + '/book', this.$data)
                .then(function (response) {
                    if(response.status == 200) {
                        window.location.href = "/booking-request/" + response.data;
                    }
                });
            },

            selectOnce(calendar_id) {
                var currentSelection = this.selectedTimeSlot[calendar_id];
                this.selectedTimeSlot = {};
                this.selectedTimeSlot[calendar_id] = currentSelection;
            },


        },

        props: ['studioId'],

    }
</script>